/**
 * Mobile Menu Vertical Arrows
 * Gestisce le frecce di scroll verticale per i grid delle categorie nel menu mobile
 */

$(document).ready(function () {
    'use strict';

    /**
     * Inizializza le frecce verticali per tutti i grid del menu mobile
     */
    function initMobileMenuVerticalArrows() {
        // Seleziona sia il primo livello (categorie) che il secondo livello (sottocategorie)
        const $level1Grids = $('.mobile-category-level-1 .mobile-categories-grid');
        const $level2Grids = $('.mobile-category-level-2 .mobile-subcategories-grid');

        // Inizializza per il primo livello
        $level1Grids.each(function () {
            initVerticalArrowsForGrid($(this).closest('.mobile-category-level-1'));
        });

        // Inizializza per il secondo livello
        $level2Grids.each(function () {
            initVerticalArrowsForGrid($(this).closest('.mobile-category-level-2'));
        });
    }

    /**
     * Inizializza le frecce verticali per un livello specifico
     */
    function initVerticalArrowsForGrid($level) {
        if (!$level.length) return;

        // Crea le frecce se non esistono
        let $topArrow = $level.find('.vertical-scroll-arrow.top');
        let $bottomArrow = $level.find('.vertical-scroll-arrow.bottom');

        if (!$topArrow.length) {
            $topArrow = $('<button>')
                .addClass('vertical-scroll-arrow top')
                .attr('aria-label', 'Scroll su')
                .html('<i class="fto-up-open"></i>');
            $level.append($topArrow);
        }

        if (!$bottomArrow.length) {
            $bottomArrow = $('<button>')
                .addClass('vertical-scroll-arrow bottom')
                .attr('aria-label', 'Scroll giù')
                .html('<i class="fto-down-open"></i>');
            $level.append($bottomArrow);
        }

        // Funzione per aggiornare la visibilità delle frecce
        function updateVerticalArrows() {
            const levelElement = $level[0];
            if (!levelElement) return;

            const canScrollUp = levelElement.scrollTop > 0;
            const canScrollDown = levelElement.scrollTop < (levelElement.scrollHeight - levelElement.clientHeight - 1);

            // Mostra le frecce solo se c'è contenuto scrollabile
            if (canScrollUp || canScrollDown) {
                $topArrow.toggleClass('visible', canScrollUp);
                $topArrow.toggleClass('disabled', !canScrollUp);
                $bottomArrow.toggleClass('visible', canScrollDown);
                $bottomArrow.toggleClass('disabled', !canScrollDown);
            } else {
                $topArrow.removeClass('visible');
                $bottomArrow.removeClass('visible');
            }
        }

        // Gestisce il click sulla freccia su
        $topArrow.off('click').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const levelElement = $level[0];
            if (levelElement) {
                const scrollAmount = levelElement.clientHeight * 0.8;
                levelElement.scrollBy({
                    top: -scrollAmount,
                    behavior: 'smooth'
                });
            }
        });

        // Gestisce il click sulla freccia giù
        $bottomArrow.off('click').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const levelElement = $level[0];
            if (levelElement) {
                const scrollAmount = levelElement.clientHeight * 0.8;
                levelElement.scrollBy({
                    top: scrollAmount,
                    behavior: 'smooth'
                });
            }
        });

        // Aggiorna le frecce quando si scrolla (con debounce per performance)
        let scrollTimeout;
        const handleScroll = function () {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(updateVerticalArrows, 50);
        };

        // Rimuovi eventuali listener precedenti e aggiungi il nuovo
        $level.off('scroll', handleScroll);
        $level.on('scroll', handleScroll);

        // Aggiorna le frecce quando la finestra viene ridimensionata
        const handleResize = debounce(function () {
            updateVerticalArrows();
        }, 150);

        // Salva il riferimento alla funzione per poterla rimuovere
        if (!$level.data('resize-handler')) {
            $level.data('resize-handler', handleResize);
            $(window).on('resize', handleResize);
        }

        // Aggiorna le frecce all'inizializzazione e dopo un breve delay
        setTimeout(updateVerticalArrows, 100);
        setTimeout(updateVerticalArrows, 500);
    }

    /**
     * Debounce function per performance
     */
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    // Inizializza quando il DOM è pronto
    initMobileMenuVerticalArrows();

    // Reinizializza quando il menu mobile viene aperto o quando cambia livello
    $(document).on('click', '.mobile-category-expand, .mobile-category-back', function () {
        setTimeout(function () {
            initMobileMenuVerticalArrows();
        }, 300); // Aspetta che l'animazione di cambio livello sia completata
    });

    // Reinizializza quando il menu accordion viene aperto
    $(document).on('click', '.mo_ml_level_0 .opener', function () {
        setTimeout(function () {
            initMobileMenuVerticalArrows();
        }, 300); // Aspetta che l'animazione dell'accordion sia completata
    });

    // Usa MutationObserver per rilevare quando il menu viene clonato/aggiornato
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes.length) {
                // Verifica se sono stati aggiunti elementi del menu
                const hasMenuElements = Array.from(mutation.addedNodes).some(function (node) {
                    if (node.nodeType === 1) { // Element node
                        return node.classList && (
                            node.classList.contains('mobile-category-level') ||
                            node.classList.contains('mobile-categories-grid') ||
                            node.classList.contains('mobile-subcategories-grid') ||
                            node.querySelector && (
                                node.querySelector('.mobile-category-level') ||
                                node.querySelector('.mobile-categories-grid') ||
                                node.querySelector('.mobile-subcategories-grid')
                            )
                        );
                    }
                    return false;
                });

                if (hasMenuElements) {
                    setTimeout(function () {
                        initMobileMenuVerticalArrows();
                    }, 200);
                }
            }
        });
    });

    // Osserva il container del menu mobile
    const menuContainer = document.getElementById('mobile_menu_container');
    if (menuContainer) {
        observer.observe(menuContainer, {
            childList: true,
            subtree: true
        });
    }

    // Reinizializza quando il menu mobile diventa visibile
    const menuVisibilityObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const target = mutation.target;
                if (target.id === 'mobile_menu_container' && target.classList.contains('visible')) {
                    setTimeout(function () {
                        initMobileMenuVerticalArrows();
                    }, 300);
                }
            }
        });
    });

    if (menuContainer) {
        menuVisibilityObserver.observe(menuContainer, {
            attributes: true,
            attributeFilter: ['class']
        });
    }
});

